export const styles = [
  {
    id: 'gl-draw-polygon-fill-inactive',
    type: 'fill',
    filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
    paint: {
      'fill-color': '#3bb2d0',
      'fill-outline-color': '#fa2323',
      'fill-opacity': 0.1,
    },
  },
  {
    id: 'gl-draw-polygon-fill-active',
    type: 'fill',
    filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
    paint: {
      'fill-color': '#fbb03b',
      'fill-outline-color': '#262323',
      'fill-opacity': 0.1,
    },
  },
  {
    id: 'gl-draw-polygon-midpoint',
    type: 'circle',
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'midpoint']],
    paint: {
      'circle-radius': 3,
      'circle-color': '#fa2323',
    },
  },
  {
    id: 'gl-draw-polygon-stroke-inactive',
    type: 'line',
    filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': '#fa2323',
      'line-width': 2,
    },
  },
  {
    id: 'gl-draw-polygon-stroke-active',
    type: 'line',
    filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': '#fa2323',
      'line-dasharray': [0.2, 2],
      'line-width': 2,
    },
  },
  {
    id: 'gl-draw-line-inactive',
    type: 'line',
    filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'LineString'], ['!=', 'mode', 'static']],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': '#fa2323',
      'line-width': 2,
    },
  },
  {
    id: 'gl-draw-line-active',
    type: 'line',
    filter: ['all', ['==', '$type', 'LineString'], ['==', 'active', 'true']],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': '#fa2323',
      'line-dasharray': [0.2, 2],
      'line-width': 2,
    },
  },
  {
    id: 'gl-draw-polygon-and-line-vertex-stroke-inactive',
    type: 'circle',
    filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point'], ['!=', 'mode', 'static']],
    paint: {
      'circle-radius': 5,
      'circle-color': '#fa2323',
    },
  },
  {
    id: 'gl-draw-polygon-and-line-vertex-inactive',
    type: 'circle',
    filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point'], ['!=', 'mode', 'static']],
    paint: {
      'circle-radius': 3,
      'circle-color': '#fa2323',
    },
  },
];

/** The style a map shows until someone picks another one. */
export const DEFAULT_MAP_STYLE = 'mapbox://styles/mapbox/streets-v12';

export const basemaps = [
  {
    id: 1,
    label: 'Mapbox Streets',
    value: 'mapbox://styles/mapbox/streets-v12',
  },
  {
    id: 2,
    label: 'Mapbox Outdoors',
    value: 'mapbox://styles/mapbox/outdoors-v12',
  },
  {
    id: 3,
    label: 'Mapbox Light',
    value: 'mapbox://styles/mapbox/light-v11',
  },
  {
    id: 4,
    label: 'Mapbox Satellite',
    value: 'mapbox://styles/mapbox/satellite-v9',
  },
];

export const mapMarkers = [
  {
    id: 1,
    value: 'blue',
    label:
      '<img height="20" src="https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_blue.png" />',
    img: 'https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_blue.png',
  },
  {
    id: 2,
    value: 'brown',
    label:
      '<img height="20" src="https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_brown.png" />',
    img: 'https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_brown.png',
  },
  {
    id: 3,
    value: 'cyan',
    label:
      '<img height="20" src="https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_cyan.png" />',
    img: 'https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_cyan.png',
  },
  {
    id: 4,
    value: 'gray',
    label:
      '<img height="20" src="https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_gray.png" />',
    img: 'https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_gray.png',
  },
  {
    id: 5,
    value: 'green',
    label:
      '<img height="20" src="https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_green.png" />',
    img: 'https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_green.png',
  },
  {
    id: 6,
    value: 'lime',
    label:
      '<img height="20" src="https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_lime.png" />',
    img: 'https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_lime.png',
  },
  {
    id: 7,
    value: 'magenta',
    label:
      '<img height="20" src="https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_magenta.png" />',
    img: 'https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_magenta.png',
  },
  {
    id: 8,
    value: 'maroon',
    label:
      '<img height="20" src="https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_maroon.png" />',
    img: 'https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_maroon.png',
  },
  {
    id: 9,
    value: 'navy',
    label:
      '<img height="20" src="https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_navy.png" />',
    img: 'https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_navy.png',
  },
  {
    id: 10,
    value: 'olive',
    label:
      '<img height="20" src="https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_olive.png" />',
    img: 'https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_olive.png',
  },
  {
    id: 11,
    value: 'orange',
    label:
      '<img height="20" src="https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_orange.png" />',
    img: 'https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_orange.png',
  },
  {
    id: 12,
    value: 'pink',
    label:
      '<img height="20" src="https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_pink.png" />',
    img: 'https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_pink.png',
  },
  {
    id: 13,
    value: 'purple',
    label:
      '<img height="20" src="https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_purple.png" />',
    img: 'https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_purple.png',
  },
  {
    id: 14,
    value: 'red',
    label:
      '<img height="20" src="https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_red.png" />',
    img: 'https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_red.png',
  },
  {
    id: 15,
    value: 'teal',
    label:
      '<img height="20" src="https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_teal.png" />',
    img: 'https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_teal.png',
  },
  {
    id: 16,
    value: 'yellow',
    label:
      '<img height="20" src="https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_yellow.png" />',
    img: 'https://s3.ca-central-1.amazonaws.com/cocoriko.dev.communities/mapMarkers/png/mapbox_marker_yellow.png',
  },
];
